import { FormFields } from ".";
import { INDIAN_STATES } from "./indiaStatesList";

export const ADDRESS_DETAILS_FIELDS: FormFields = {
  fields: [
    {
      name: "type",
      label: "Address Type",
      type: "select",
      options: ["PERMANENT", "CURRENT", "WORK", "PROJECT_SITE", "OTHERS"],
      validationRules: {
        required: "Address type is required",
      },
    },
    {
      name: "line1",
      label: "Address Line 1",
      type: "text",
      validationRules: {
        required: "Address line 1 is required",
      },
    },
    {
      name: "line2",
      label: "Address Line 2",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "landmark",
      label: "Landmark",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "city",
      label: "City",
      type: "select",
      options: [],
      validationRules: {
        required: "City is required",
      },
    },
    {
      name: "state",
      label: "State",
      type: "select",
      options: INDIAN_STATES,
      validationRules: {
        required: "State is required",
      },
    },
    {
      name: "postalCode",
      label: "Postal Code",
      type: "text",
      validationRules: {
        required: "Postal code is required",
        pattern: {
          value: /^\d{6}$/,
          message: "Postal code must be 6 digits",
        },
      },
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      defaultValue: "India",
      validationRules: {
        required: "Country is required",
      },
    },
    {
      name: "ownership",
      label: "Ownership",
      type: "select",
      options: ["OWNED", "RENTED", "LEASED", "COMPANY_PROVIDED", "FAMILY_OWNED"],
      validationRules: {
        required: "Ownership is required",
      },
    },
    {
      name: "monthlyRent",
      label: "Monthly Rent (if applicable)",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(0|[1-9]\d*)$/,
          message: "Enter a valid amount",
        },
      },
    },
    {
      name: "yearsOfStay",
      label: "Years of Stay",
      type: "tel",
      validationRules: {
        required: "Years of stay is required",
        pattern: {
          value: /^(0|[1-9]\d*)$/,
          message: "Enter a valid number",
        },
      },
    },
  ],
};
